import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const AllCompanies = React.lazy(() => import('.'));

export const allCompaniesRoutes = [
  new Route({
    path: 'all-companies',
    element: AllCompanies,
    children: [],
  }),
];
